/* eslint-disable no-unused-vars,no-console */
import debugFactory from "debug";
import { clientIdentifier, listenTo } from "@teaming/io-helpers";
import { SocketMessageType } from "@teaming/common-enums";

export function configureSockets( { storeName, store, navigation, ioSocket, ioTeam, alerts, } ) {
	const debug = debugFactory( `teaming:common-team:stores:${ storeName }:sockets` );
}

export function configureChannels( { storeName, store, navigation, ioChannel, ioMeeting, alerts, } ) {
	const debug = debugFactory( `teaming:common-team:stores:${ storeName }:channels` );
	const { error, } = alerts;


	listenTo( ioChannel, "user.saveAssessment", {
		success() {
			store.commit( `${ storeName }/hideWorkStyleDialog` );
			setTimeout( () => {
				store.dispatch( `${ storeName }/refreshTeam` );
				// eslint-disable-next-line no-magic-numbers
			}, 200 );
		},
		error() {
			error( "workStyleError" );
		},
	} );
}
